/**
 * 원화 표기 유틸 — 금액 표시 포맷의 SSoT.
 * 백엔드·스텁이 내려주는 금액은 숫자(원)이며, 천단위 구분 표기는 여기서만 변환한다
 * (컴포넌트마다 toLocaleString 재현 금지 — ESLint 가 막는다, datetime 의 formatKst 와 동일한 원칙).
 */

/** 숫자 금액(원) → 천단위 구분 문자열(예: 50000 → '50,000'). 통화 기호·단위는 호출부가 소유. */
const WON = new Intl.NumberFormat('ko-KR');

export function formatWon(amount: number): string {
  return WON.format(amount);
}
